export class FacturacionClass {
	constructor(
		public item_num?: number,
		public codalm?: string,
		public codter?: string,
		public nomter?: string,
		public feccom?: string,
		public valorcom?: number,
		public codusu?: string,
		public idResolucionDian?: number,
		public cantidad?: number,
		public codins?: string,
	) {
		this.item_num = null;
		this.codalm = null;
		this.codter = null;
		this.nomter = null;
		this.feccom = null;
		this.valorcom = null;
		this.codusu = null;
		this.idResolucionDian = null;
		this.cantidad = null;
		this.codins = null;
	}
}